import React from "react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";

export function MaterialThemeProvider(props) {
  const { children } = props;
  const theme = createMuiTheme({
    direction: "rtl",
    typography: {
      fontFamily: ["iranyekan !important"].join(","),
      // fontSize:"13px"
    },
    palette: {
      type: "light",
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#17c191",
        lighter: "#D0F2E9",
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: "#3783e7",
        lighter: "#AFCDF5",
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: "#ff0952",
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      grey: {
        main: "#d6d6d6",
      },
    },

    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: false, // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 0,
      },
    },
    overrides: {
      MUIDataTableToolbar: {
        actions: {
          flex: 0,
          display: "flex",
        },
      },
      MuiInputLabel: {
        formControl: { right: 0 },
      },
      MuiAutocomplete: {
        endAdornment: {
          left: 0,
          right: "auto",
        },
      },
      MuiBadge: {
        colorPrimary: {
          color: "#fff",
        },
      },
      MUIDataTableToolbarSelect: {
        root: {
          zIndex: 1,
          boxShadow: "none",
          padding: "0 20px",
          height: "50px",
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          zIndex: 0,
        },
        fixedLeft: {
          zIndex: 0,
        },
      },
      MuiTableCell: {
        head: {
          fontWeight: "bold",
          backgroundColor: "#eee !important",
          zIndex: 0,
          // position:"fixed",
          padding: "10px",
        },
        root: {
          cursor: "pointer",
          borderColor: "#d3d3d3",
          zIndex: 0,
          padding: "5px 10px",
        },
      },
      MUIDataTableHeadRow: {
        root: {
          padding: 15,
        },
      },
      MuiChip: {
        deleteIcon: {
          margin: "0 !important",
          marginLeft: "5px !important",
        },
      },
      MuiDialog: {
        paperScrollPaper: {
          overflow: "hidden",
        },
        paperScrollBody: {
          textAlign: "right",
        },
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
